<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Localizar Consultas</h2>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">

                    <form [formGroup]="formularioDeLocalizacaoDeConsulta" (ngSubmit)="onSubmit()">

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-12 col-12">
                                <mat-label>Filial</mat-label>
                                <mat-select value="Filial" formControlName="idFilial" name="idFilial" id="idFilial"
                                    required>
                                    <mat-option *ngFor="let filial of listaFiliais" [value]="filial.id">
                                        {{filial.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeLocalizacaoDeConsulta.controls.idFilial.hasError('required')">
                                    O campo Filial é obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-12 col-12">
                                <mat-label>Data</mat-label>
                                <input matInput [matDatepicker]="dataMarcacaoDP" formControlName="dataMarcacao"
                                    id="dataMarcacao" name="dataMarcacao">
                                <mat-datepicker-toggle matSuffix [for]="dataMarcacaoDP"></mat-datepicker-toggle>
                                <mat-datepicker #dataMarcacaoDP></mat-datepicker>

                                <mat-error
                                    *ngIf="formularioDeLocalizacaoDeConsulta.controls.dataMarcacao.hasError('invalidDate')">
                                    O campo Data está inválido.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                                <mat-label>Médico</mat-label>
                                <mat-select value="Médico" formControlName="idMedico" name="idMedico" id="idMedico">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let medico of listaMedicos" [value]="medico.id">
                                        {{medico.nome}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            
                            <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                                <mat-label>Consulta</mat-label>
                                <mat-select value="Consulta" formControlName="idProcedimentoConsulta"
                                    name="idProcedimentoConsulta" id="idProcedimentoConsulta">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let procedimentoConsulta of listaProcedimentoConsulta"
                                        [value]="procedimentoConsulta.id">
                                        {{procedimentoConsulta.nome}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-12 col-sm-12 col-12">
                                <mat-label>Paciente</mat-label>
                                <input matInput value="Paciente" class="form-control" id="nomePaciente" trim="blur"
                                    name="nomePaciente" formControlName="nomePaciente" maxlength="60" upperCase>

                                <mat-error
                                    *ngIf="formularioDeLocalizacaoDeConsulta.controls.nomePaciente.hasError('minlength')">
                                    O campo Paciente precisa conter mais do que 2 caracteres.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-2 col-md-9 col-sm-9 col-12">
                                <mat-label>CPF</mat-label>
                                <input matInput value="CPF" class="form-control" id="cpf" trim="blur" name="cpf"
                                    formControlName="cpf" maxlength="14" trim="blur" nccCpfCnpjMask>
                                <mat-error *ngIf="formularioDeLocalizacaoDeConsulta.controls.cpf.errors">
                                    O campo CPF está inválido.
                                </mat-error>
                            </mat-form-field>

                            <div class="form-group col-lg-2 col-md-3 col-sm-3 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeLocalizacaoDeConsulta.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>
                        </div>

                    </form>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="horaAtendimento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hora Atd. </th>
                            <td mat-cell *matCellDef="let marcacaoDTO">
                                {{marcacaoDTO.dataMarcacao | date:"dd/MM/yyyy"}}
                                {{marcacaoDTO.horaAtendimento | horaFormatadaPipe}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomePaciente">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Paciente </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.nomePaciente}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="indTitular">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Titular </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.indTitular}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cpf">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CPF </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.cpf | mask: '999.999.999-99'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nomePlanoSaude">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Convênio </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.nomePlanoSaude}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomeProcedimentoConsulta">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Consulta </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.nomeProcedimentoConsulta}} </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center" mat-sort-header> Status
                            </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" class="table-column-center">
                                <mat-icon class="mat-18 custom-cursor" color="{{marcacaoDTO.getCorStatusMarcacao()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{marcacaoDTO.getTooltipStatusMarcacao()}}"
                                    (click)="executarAcaoDoStatusSelecionado(marcacaoDTO)">
                                    {{marcacaoDTO.getIconeStatusMarcacao()}}
                                </mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="detalhe">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Detalhe </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" class="table-column-center">
                                <mat-icon class="mat-18" color="{{marcacaoDTO.getCorCobrarAtendimento()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{marcacaoDTO.getTooltipCobrarAtendimento()}}">
                                    {{marcacaoDTO.getIconeCobrarAtendimento()}}
                                </mat-icon>
                                <mat-icon class="mat-18" color="{{marcacaoDTO.getCorPNE()}}"
                                    style="vertical-align: middle;" matTooltip="{{marcacaoDTO.getTooltipPNE()}}">
                                    {{marcacaoDTO.getIconePNE()}}
                                </mat-icon>
                                <mat-icon class="mat-18" color="{{marcacaoDTO.getCorPeriodoVolta()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{marcacaoDTO.getTooltipPeriodoVolta()}}">
                                    {{marcacaoDTO.getIconePeriodoVolta()}}
                                </mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="acoes">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Ações </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" class="table-column-center">
                                <button mat-icon-button color="primary" (click)="details(marcacaoDTO)"
                                    matTooltip="Info">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                                <button mat-icon-button color="mat-print" (click)="imprimirAgendamento(marcacaoDTO)"
                                    matTooltip="Imprimir Agendamento">
                                    <mat-icon class="mat-18">print</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="cancelar(marcacaoDTO)"
                                    matTooltip="Cancelar">
                                    <mat-icon class="mat-18">cancel</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="confirmDelete(marcacaoDTO)"
                                    matTooltip="Remover" [hidden]="ocultarOpcaoExcluir">
                                    <mat-icon class="mat-18">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>